import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  refundApprovalLabel: {
    id: 'gHXM0h',
    description: 'Label for the line item refund approval button group',
    defaultMessage: 'Refund Decision',
  },
  exchangeApprovalLabel: {
    id: 'fN24EW',
    description: 'Label for the line item exchange approval button group',
    defaultMessage: 'Exchange Decision',
  },
  decisionLabel: {
    id: 'D9B76k',
    description: 'Label for the line item approval button group when the item can be either refunded or exchanged',
    defaultMessage: '{isExchange, select, true {Exchange} other {Refund}} Decision',
  },
  acceptApprovalText: {
    id: '8NeTNa',
    description: 'Text for the accept button in the line item approval action button group',
    defaultMessage: 'Accept',
  },
  rejectApprovalText: {
    id: 'Es1LHP',
    description: 'Text for the reject button in the line item approval action button group',
    defaultMessage: 'Reject',
  },
  restockLabel: {
    id: 'R11Vap',
    description: 'Label for the restock action button group',
    defaultMessage: 'Restock Item',
  },
  acceptRestockText: {
    id: 'f+a9Qe',
    description: 'Text for the accept button in the restock action button group',
    defaultMessage: 'Restock',
  },
  rejectRestockText: {
    id: 'TDtyU9',
    description: 'Text for the discard button in the restock action button group',
    defaultMessage: 'Discard',
  },
});
